"use client";

import React from "react";
import { Navigate, useLocation, Outlet } from "react-router-dom";
import { useAppConfigStore } from "~/src/store/app-config-store";

/**
 * MaintenanceGuard - Redirects to maintenance page if maintenance mode is enabled
 * Redirects away from maintenance page if maintenance mode is disabled
 */
export const MaintenanceGuard: React.FC = () => {
  const location = useLocation();
  const maintenanceConfig = useAppConfigStore(
    (state) => state.basicConfig.maintenance
  );

  const isMaintenance = maintenanceConfig != null;

  // If maintenance mode is enabled and not on maintenance page, redirect to maintenance
  if (isMaintenance && location.pathname !== "/maintenance") {
    return <Navigate to="/maintenance" replace />;
  }

  // If maintenance mode is disabled and on maintenance page, redirect to login
  if (!isMaintenance && location.pathname === "/maintenance") {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};
